import PropTypes from 'prop-types'

const QREventHeader = ({ title }) => {
    return (
        <header className='header'>
            <h1>{title}</h1>
        </header>
    )
}

QREventHeader.defaultProps = {
    title: 'QR Events',
}

QREventHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default QREventHeader
